import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import * as actions from 'actions';

import OAuthButtonManager from './OAuthButtonManager';

const LOGIN_MAP = {
  twitter: 'Log in with Twitter',
  facebook: 'Log in with Facebook',
  linkedin: 'Log in with LinkedIn',
  google: 'Log in with Google',
};

const REGISTRATION_MAP = {
  twitter: 'Register with Twitter',
  facebook: 'Register with Facebook',
  linkedin: 'Register with LinkedIn',
  google: 'Register with Google',
};

class OAuthButtons extends PureComponent {
  getTextMap = () => {
    const { authType } = this.props;
    if (authType === 'login') {
      return LOGIN_MAP;
    } else {
      return REGISTRATION_MAP;
    }
  };

  render() {
    const { authType } = this.props;
    return (
      <div className="OAuthButtons">
        <OAuthButtonManager
          buttonTextMap={this.getTextMap()}
          authType={authType}
        />
      </div>
    );
  }
}

OAuthButtons.propTypes = {
  authType: PropTypes.oneOf(actions.VALID_AUTH_TYPES),
};

export default OAuthButtons;



// WEBPACK FOOTER //
// ./src/Components/Auth/OAuthButtons.js